module.exports = __webpack_public_path__ + "media/images/recruitment/landing/img_feature03-b0813df8061e402c57f372f2518914d4.png";